<template>
    <div class="card mainCard my-4">
        <!--GREETINGS HEADER-->
            <div class="lead card-header text-success text-center bg-light">
                Thank you for your purchase! Please provide more information!
                    </div>

                <div v-if="cameFrom">
                    <small>
                        <table class="table table-responsive text-dark text-left">
                            <tr>
                                <td>Ref:</td>
                                <td>{{cameFrom}}</td>
                            </tr>
                            <tr>
                                <td>Size:</td>
                                <td>{{tileSize}}</td>
                            </tr>
                        </table>                     
                    </small>                 
                </div>             
      
<div class="card-body text-left">
    <form>
        <div class="row">
        <!-- PERSONAL INFO-->                        
            <div class="col-md-6">
                <h3 class="text-info mt-5">INFO:<br> <small class="text-muted border-top">Contact Information</small></h3>

        <!-- EMAIL-->
                <div class="email form-group mt-4">
                    <p class="text-dark">Please provide email for questions/follow-ups. <br> We will also use this email to send you layout for review <span class="text-danger">*</span></p>
                    <label class="lead" for="email">Email address:</label>
                    <input type="email" 
                            class="form-control" 
                            id="email" 
                            @input="$v.email.$touch()" 
                            v-model="email">
                    <small id="emailHelp" class="form-text text-info">We'll never share your email with anyone else</small>
                    <p class="text-danger" v-if="!$v.email.email">* Please provide a valid email</p>
                    <p class="text-danger" v-if="!$v.email.required">* The email address is required</p>
                </div>
            <hr>
        <!-- WHAT ANIMAL-->
                <div class="choose-animal form-group">
                    <p class="mt-3 text-dark">
                        Can you tell us what animal is this memorial for?</p>
                    <label class="lead" for="animal-option">Choose animal:</label>
                    <select class="form-control" id="animal-option" v-model="animalType">
                        <option value="">Select an animal</option>
                        <option v-bind:value="anim.name" v-for="(anim, index) in AnimalList" :key="index">{{ anim.name }}</option>
                    </select>
                </div>
            </div>

        <!-- DESCRIPTION ABOUT CREATION-->
                <div class="col-md-6">
                    <div class="notes form-group text-muted mb-3">
                        <h3 class="text-info mt-5">DESCRIPTION:<br> <small class="text-muted border-top">Notes To Designer</small></h3>
                        <p class="lead mt-4">Please tell us:</p>
                        <ol class="text-dark">
                            <li>How you would like your memorial to look</li>
                            <li>What photographs or images are you providing and how should they be edited?</li>
                            <li>What text should we put as header, and what to use in the body?</li>
                        </ol>
                        <p class="text-justify text-dark mt-4">
                            We provided a couple of links below for ideas on epitaphs. Those links will open in a new browser window. <span class="text-danger">*</span>
                        </p>
                        <textarea @input="$v.description.$touch()" class="form-control" id="description" rows="3" v-model="description"></textarea>
                        <p class="text-danger" v-if="!$v.description.required">* The description is required</p>                                
                        <br>
                    </div>
                </div>
            </div>

        <!-- SILHUETTE OR UPLOAD -->
            <transition name="fade">
                <div v-if="animalType=='Dog' || animalType == 'Cat'" class="text-center my-3">
                    <div class="row justify-content-center">
                        <div class="col-sm-12 col-md-10 col-lg-10 text-left">
                            <h4 class="text-info"><i class="fas fa-arrow-circle-down"></i> Do you have any pictures of your pet?</h4><br>
                                <div class="custom-control custom-radio">
                                    <input type="radio" id="rad1" name="uploadOrsilhouette" @click="isPetPicture = 'yes'" class="custom-control-input">
                                    <label class="custom-control-label" for="rad1">Yes, and I'm ready to upload it now</label>
                                </div>
                                <div class="custom-control custom-radio">                        
                                    <input type="radio" id="rad2" name="uploadOrsilhouette" @click="isPetPicture = 'no'" class="custom-control-input">
                                    <label class="custom-control-label" for="rad2">No, I will choose some pet's silhouette</label>
                                </div>                              
                        </div>
                        
                    </div>                  
                </div>
            </transition>

        <!-- DOGS -->
            <transition name="fade">            
                <app-dogs v-if="isPetPicture == 'no' && animalType == 'Dog'" @getThisDog="getDog($event)" @removeThisDog="removeDog" />
            </transition>

        <!-- CATSS -->
            <transition name="fade">            
                <app-cats v-if="isPetPicture == 'no' && animalType == 'Cat'" @getThisCat="getCat($event)" @removeThisCat="removeCat" />
            </transition>
           
        <!-- DOWNLOAD SHIT -->
            <div v-if="isPetPicture == 'yes'">

        <!-- IMAGE -->
            <div class="images my-4 text-muted">
                <h3 class="text-info my-5">IMAGES: <br> <small class="text-muted border-top">Inspiration Image</small></h3>
                <a href="http://www.petsatrest.co.uk/pages/1653/Pet-Memorial-Wording-Ideas/" target="_blank">Pet memorial wording - link for inspiration 1</a><br>
                <a href="https://www.pinterest.ca/explore/pet-memorials/?lp=true" target="_blank">Pet memorial wording - link for inspiration 2</a>

                <div class="row mt-3">
                    <div class="col-md-6">
                        <p class="text-justify">In case you want us to engrave portrait of your pet on memorial:<br> Please load the photos of your pet - you can load up to 3 photos max size 20 MB each, and our artists will select the best one. Or if you want those photographs
                            combined, please provide detailed instructions above.</p>
                        <p class="text-justify">If your pet is photographed with other pets, or persons - do not worry, we will crop them out. Just provide clear and unambigious instructions of what need to be done with image(s) you are giving us.</p>
                    </div>
                    <div class="col-md-6">
                        <p class="text-justify">In case you do not have photos of your pet, we can add solouette of the corresponding breed / animal, or you can search on google and send us the photo of animal that looks exactly like yours: Use this
                            <a href="https://images.google.com/"> web site to search for images</a></p>
                        <p class="text-justify">It is also perfectly ok if you do not want photograps or other images on your stone, we can do text-only as well.</p>
                    </div>
                </div>
            </div>
            <hr>

        <!-- DROP IMAGES :name, key, mode - это всё для анимаций-->                    
            <transition :name="uploadAnimation" mode="out-in">
                <div key="filesinfo" v-if="files.length > 0">
                <h3 class="text-success text-center mt-4">Your Files to Upload:</h3>
                    <div class="row my-4">
                        <div class="col mt-3" v-for="(file, index) in imgObj" :key="index">
                            <p><small><span class="lead">name:</span> {{ file.imName }}<br> 
                            <span class="lead">size:</span> {{ formatBytes(file.imSize) }}</small></p> 
                                    <img class="rounded" :src="file.imPath" height="100">
                                <hr>
                            </div>
                        </div>                                            
                    </div>                                        
                <div key="dropzone" v-else>
                <app-uploader @getUploadFiles="getFiles($event)" />
                </div>
            </transition> 

        <!-- USING PIC IN PORTFOLIO RADIO -->
            <div class="my-5 text-center">
                <p class="textdanger" :class="{'text-success' : usingPixInPortfolio}">I allow to use final photo in your portfolio</p>
                <input type="radio" id="yes" value="true" v-model="usingPixInPortfolio">
                    <label for="yes">Yes</label>&nbsp;&nbsp;
                        
                <input type="radio" id="no" value="false" v-model="usingPixInPortfolio">
                    <label for="no">No</label>
            </div>

        <!-- USING PIC IN PORTFOLIO CHECKBOX
            <div class="custom-control custom-checkbox text-center my-5">
                <input class="custom-control-input mt-1" type="checkbox" id="usingPixInPortfolio" value="usingPixInPortfolio" v-model="usingPixInPortfolio"> 
                <label class="custom-control-label textdanger" for="usingPixInPortfolio" :class="{'text-success':usingPixInPortfolio}">I allow to use the final photo in your portfolio </label>
                </div> 
            -->                
            </div>

        <!-- CONTENT-ALIGNMENT-->
            <div class="content-alignment my-5 text-muted">
                <h3 class="text-info mt-5">LAYOUTS: <br> <small class="text-muted border-top">Choose a Layout</small></h3>
                    <p class="text-justified">
                        Please identify the layout of text and image that appeals to you. Skip this selection if you want our artists to use their own judgement.
                    </p>

                    <div class="text-info my-5 text-center">
                        <h4><i class="fas fa-arrow-circle-down"></i> Click on layout image you like!</h4>
                    </div>

                    <div class="row mb-5">
                        <div class="col-md-4 col-sm-12" v-for="(layout, index) in layouts" :key="index">
                            <div class="h6 text-center laybox">{{ layout.title }}</div>
                            <div @click="selectLayout(layout.nick)" :class="[{'layout-selected' : selectedLayout === layout.nick}, layout.nick]">
                                <img class="img-fluid" v-bind:src="layout.lay_img" alt="Monument Layout">
                            </div><br><br>
                            <div class="layout-form-check" v-show="selectedLayout === layout.nick">
                                <i class="far fa-times-circle fa-2x" @click="selectedLayout = null"></i>
                            </div>

                            <!--КАРТИНКА "SELECTED" 
                                <transition name="fade">
                                <div class="layout-form-check" v-show="selectedLayout === layout.nick">
                                    <img class="img-fluid layout-close rounded" 
                                            src="static/img/layouts/selected_layout.png" 
                                            @click="selectedLayout = null" 
                                            alt="Selected Layout">
                                </div>
                                </transition> 
                            -->
                        </div>
                    </div>
            </div><br>

        <!-- FONTS -->
                <div class="title-font mt-4 mb-5">
                        <h3 class="text-info mt-5">FONTS: <br> <small class="text-muted border-top">Please choose title / name & text fonts:</small></h3>
                        <p class="mb-5 text-justify">
                            Please choose font that you would like to use for title / name (Larger Letters). You can choose up to 3 options that appeal to you, or leave this section empty, in which case our artist will use their own judgement.
                        </p>
                    <div class="memorial-container mb-3 rounded">
                        <div class="row">
                            <div class="col-md bg-black rounded text-center mb-15">
                                <div class="buffer d-none d-md-block">&nbsp;</div>
                                <div class="monument-font">
                                        <p :style="{fontFamily:selectedFontMemo, fontSize: fontSizes.animalMemoSize+'pt'}" class="text-light">{{ animalMemo }}</p>                            
                                        <span :style="{fontFamily:selectedFontTitle, fontSize: fontSizes.animalNameSize+'pt'}" class="text-light">{{ animalName }}</span><br>
                                        <p :style="{fontFamily:selectedFontDates, fontSize: fontSizes.animalDatesSize+'pt'}" class="text-light"><small>{{ animalDates }}</small></p>
                                        <p :style="{fontFamily:selectedFontText}" class="text-light"><span v-html="animalText"></span></p>                                  
                                </div>
                            </div>
                            <div class="col-md text-center">
                                <div class="bg-light rounded mb-3 p-3">
                                    <p class="lead text-dark mt-4">In Memory:</p>
                                    <input class="form-control p-1 mb-4" type="text" v-model="animalMemo">
                                    <div class="row">
                                        <div class="col">
                                                <app-font-memo class="font-control" @get-font-memo="getInMemoryFont" />
                                        </div>
                                        <div class="col">
                                            <select class="form-control" id="sel-in-memo" v-model="fontSizes.animalMemoSize">
                                                <option value="" selected>Select a size</option>
                                                <option v-bind:value="option.value" 
                                                        v-for="(option, index) in sizes" 
                                                        :key="index">
                                                        {{option.key}}
                                                </option>    
                                            </select> 
                                        </div>
                                    </div>                                   
                                </div>
                                <div class="bg-light rounded mb-3 p-3">
                                    <p class="lead text-dark mt-4">Animal Title:</p>
                                    <input class="form-control p-1 mb-4" type="text" v-model="animalName">
                                    <div class="row">
                                        <div class="col">
                                            <app-font-title class="font-control" @get-font-title="getTitleFont" />                                         
                                        </div>
                                        <div class="col">
                                            <select class="form-control" id="sel-in-name" v-model="fontSizes.animalNameSize">
                                                <option value="" selected>Select a size</option>
                                                <option v-bind:value="option.value" 
                                                        v-for="(option, index) in sizes" 
                                                        :key="index"
                                                        >
                                                        {{option.key}}
                                                </option>    
                                            </select> 
                                        </div>
                                    </div>                                   
                                </div>
                                <div class="bg-light rounded mb-3 p-3">
                                    <p class="lead text-dark mt-4">Dates of Living:</p>
                                    <input class="form-control p-1 mb-4" type="text" v-model="animalDates">
                                    <div class="row">
                                        <div class="col">
                                            <app-font-dates class="font-control" @get-font-dates="getDatesFont" />
                                        </div>
                                        <div class="col">
                                            <select class="form-control" id="sel-in-dates" v-model="fontSizes.animalDatesSize">
                                                <option value="" selected>Select a size</option>
                                                <option v-bind:value="option.value" 
                                                        v-for="(option, index) in sizes" 
                                                        :key="index">
                                                        {{option.key}}
                                                </option>    
                                            </select> 
                                        </div>
                                    </div>                                        
                                </div>                                    
                                <div class="bg-light rounded mb-3 p-3">
                                    <p class="lead text-dark mt-4">Monument Text</p>
                                        <div class="my-3">
                                            <app-font-text class="font-control" @get-font-text="getTextFont" />     
                                        </div>                                      
                                        <app-editor api-key="33n28x1cdxlgzldiflue4944kydqr68cr4528y6tcbm7vv1c" 
                                                    :init="{menubar: false, toolbar: 'undo redo | fontsizeselect | bold italic backcolor | alignleft aligncenter alignright alignjustify'}" 
                                                    v-model="animalText">
                                        </app-editor>                
                                        <!--<textarea class="form-control p-2 mb-4" rows="5" v-model="animalText"></textarea>-->                                         
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

        <!-- ORNAMENTS -->
                <div class="ornaments my-4">
                        <h3 class="text-info my-3">ORNAMENTS: <br> <small class="text-muted border-top"> Oprional Ornaments</small></h3>
                        <p class="text-justify">
                            Would you like us to add some ornaments, frames etc? Here are just some ideas to get you started. Feel free to choose any or more than one. This is an optional item. Also, it is ok to provide your own ideas in the description of the job at the beginning
                            of this form.
                        </p>
                        <div class="row">
                            <div class="col-md-3 col-sm-6" v-for="(ornament, index) in ornaments" :key="index">
                                <div class="ornament-frame">
                                    <img @click="selectOrnament(ornament.title)" :src="'static/img/ornaments/' + ornament.orn_img" alt="" class="img-fluid rounded">
                                    <transition name="fade">
                                        <div class="orn-check-frame" v-show="selected_ornaments.includes(ornament.title)" @click="removeOrnament(ornament.title)">
                                            <img class="img-fluid" src="static/img/ornaments/selected_ornament.png" alt="Selected Ornament">
                                        </div>
                                    </transition>
                                </div>
                            </div>
                        </div>
                </div>

            <!-- REQIRED DATE
                <div class="requred-date my-4">
                        <h3 class="text-info my-5">DEADLINE: <br> 
                            <small class="text-muted border-top">Required Complition Date: {{ date }}</small></h3>
                        <app-date-picker @update-date="updateDate" date-format="dd MM yy"></app-date-picker>
                </div> 
            -->

        <!-- CONFIRNATION WINDOW -->
                    <p class="alert alert-danger" v-if="errorMessage"><span v-html="errorMessage"></span></p>
                    <p class="alert alert-success" v-if="successMessage"><span v-html="successMessage"></span></p>               
                    <button :disabled="$v.$invalid" type="submit" class="my-4 py-3 btn btn-outline-secondary btn-block" @click.prevent="confirmData">Submit</button>
                </form>
                <transition name="fade">
                    <div class="modBackground" v-if="showingResultModal">
                        <div class="modalContainer">
                            <div class="modalHeading bg-info text-light">
                                Caution
                            </div> 
                            <div class="card-text modalContent rounded text-center">
                                    <div class="text-left">
                                        <p>
                                            <small>User:</small> {{ email }}<br>
                                            <small>Animal:</small> {{ animalType }}<br>
                                            <small>Note:</small> {{ description }}<br>
                                        </p>                                
                                    </div>
                                    <hr>
                                <div class="h3 text-danger my-4">Are you ready to send order?</div> 
                                <button class="btn btn-outline-danger" @click="showingResultModal = false"><i class="fas fa-arrow-circle-left"></i> No, Go Back To Edit</button>
                                <button class="btn btn-outline-success" @click="sendData"><i class="fas fa-arrow-circle-right"></i> Yes, Send Data</button>
                            </div>
                        </div>
                    </div>
                </transition>
    </div>               
</div>
</template>

<script>
    import Editor from '@tinymce/tinymce-vue'
    import uploader from '@/components/Helpers/Uploader.vue'
    import datepicker from '@/components/JQueryPluggins/DatePicker.vue'
    import fontmemo from '@/components/JQueryPluggins/FontMemo.vue'
    import fonttitle from '@/components/JQueryPluggins/FontTitle.vue'
    import fonttext from '@/components/JQueryPluggins/FontText.vue'
    import fontdates from '@/components/JQueryPluggins/FontDates.vue'
    import dogs from '@/components/JQueryPluggins/Dogs.vue'
    import cats from '@/components/JQueryPluggins/Cats.vue'
    import Data from '@/data/data' 
    import axios from 'axios'
    import { required, email } from 'vuelidate/lib/validators'

    import { mapActions } from 'vuex'

    const formData = new FormData()

    export default {
        components: {
            appEditor: Editor,
            appUploader: uploader,
            appDatePicker: datepicker,
            appFontMemo: fontmemo,
            appFontTitle: fonttitle,
            appFontText: fonttext, 
            appFontDates: fontdates, 
            appDogs: dogs, 
            appCats: cats               
            },
        data() {
            return {
                apiURL: process.env.APP_API, 
                orders: [],
                errorMessage: '',
                successMessage: '',

                isPetPicture:'',
                showingResultModal: false,

                AnimalList: Data.animals,
                layouts: Data.layouts,    
                ornaments: Data.ornaments,
                sizes: Data.sizes,    

                animalMemo: 'Our Beautiful Boy',
                animalName: 'Clifford',
                animalDates: '2001 - 2017',        
                animalText: 'Dear Friend.<br> Always loved & Forever Missed',
                date: null,
                usingPixInPortfolio: true,

                cameFrom: '', // Пока что такая заглушка
                tileSize: '',  // Пока что такая заглушка 
        
                fontSizes: { 
                    animalMemoSize: '',
                    animalNameSize: '',
                    animalDatesSize: '' 
            },
                
            selectedFontMemo: '',
            selectedFontTitle: '',
            selectedFontDates: '',
            selectedFontText: '',
            email: '',
            description: '',                
            animalType: '',
            imgObj: [],
            uploadAnimation: 'fade',
            files: [],
            selectedLayout: null,
            selectedLayoutText: '',
            selectedOrnament: [],
            selectedDog: null,
            selectedCat: null,
            selected_ornaments: [],
    
            processQueue: false,
            showRemoveAllButton: false
            }
            },
        validations: {
                email: {
                    required,
                    email
                },
                description: {
                    required
                }
            },
        created() {
            if(this.$route.params.from) {
                var pattFrom = /^[a-z]+$/
                var cf = this.$route.params.from

                if(cf.match(pattFrom)) {
                    console.log('REGEX: location matched: ' + cf)
                    this.cameFrom = this.$route.params.from
                } else {
                    console.log('REGEX: unrecognized location detected!')
                    this.cameFrom = 'unrecognized'
                }                
            }

            if(this.$route.params.size) {
                var pattSize = /\b\d\d[Xx]\d\d\b/
                var ps = this.$route.params.size

                if(ps.match(pattSize)){
                    console.log('REGEX: size matched: ' + ps)
                    this.tileSize = this.$route.params.size
                } else {
                    console.log('REGEX: unrecogined size detected!')
                    this.tileSize = 'unrecognized'
                }                
            }

            },
        methods: {
                getInMemoryFont(memo){
                    this.selectedFontMemo = memo
                    },        
                getTitleFont(title){
                    this.selectedFontTitle = title
                    },
                getTextFont(text){
                    this.selectedFontText = text           
                    },
                getDatesFont(dates){
                    this.selectedFontDates = dates            
                    },
                updateDate(date) {
                    this.date = date;
                    },
                selectLayout(selected) {           
                        this.selectedLayout = selected;
                        switch(selected) {
                            case "imgLeft":
                            this.selectedLayoutText = 'image_on_left.jpg'
                            break;
                            case "imgRight":
                            this.selectedLayoutText = 'image_on_right.jpg'
                            break;                
                            case "imgMiddle":
                            this.selectedLayoutText = 'image_on_middle.jpg'
                            break;
                        }            
                    },
                selectOrnament(selected) {
                        this.selected_ornaments.push(selected)
                        this.isOrnSelected = true
                    },
                removeOrnament(title) {
                        var index = this.selected_ornaments.indexOf(title)
                        this.selected_ornaments.splice(index, 1)            
                    },
                formatBytes(bytes){
                    const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
                    let l = 0, n = parseInt(bytes, 10) || 0;
                        while(n >= 1024 && ++l)
                            n = n/1024;
                        return(n.toFixed(n >= 10 || l < 1 ? 0 : 1) + ' ' + units[l]);
                    },
                getFiles(images){
                        Array.from(images).map(image => {
                        formData.append('images[]', image) 

                        this.files.push(image)
                        this.previewFile(image) 
                        })
                    },
                previewFile(image) {
                        const reader = new FileReader()
                        reader.addEventListener('load', () => {
                        var img = {
                                imName: image.name,
                                imPath: reader.result,
                                imSize: image.size
                            }
                            this.imgObj.push(img)
                        })
                        reader.readAsDataURL(image)
                    },
                getDog(dog){
                        this.selectedDog = dog
                    // console.log('Выбрана собака', this.selectedDog)
                    },
                removeDog(){
                        this.selectedDog = null
                    // console.log('Выбрана собака', this.selectedDog)
                    },
                getCat(cat){
                        this.selectedCat = cat
                    // console.log('Выбрана кошка', this.selectedCat)
                    },
                removeCat(){
                        this.selectedCat = null
                    // console.log('Выбрана кошка', this.selectedCat)
                    },        
                confirmData(){
                        this.showingResultModal = true
                    },
                sendData(){

                    // formData.append('dateComplition', this.date)

                    formData.append('images[]', this.files)
                    formData.append('email', this.email)
                    formData.append('description', this.description)            
                    formData.append('animalType', this.animalType)
                    formData.append('cameFrom', this.cameFrom)
                    formData.append('tileSize', this.tileSize)
                    formData.append('animalMemo', this.animalMemo)           
                    formData.append('animalMemoFont', this.selectedFontMemo)
                    formData.append('animalMemoSize', this.fontSizes.animalMemoSize)                                
                    formData.append('animalDates', this.animalDates)
                    formData.append('animalDatesFont', this.selectedFontDates)                    
                    formData.append('animalDatesSize', this.fontSizes.animalDatesSize)            
                    formData.append('animalName', this.animalName)
                    formData.append('animalNameFont', this.selectedFontTitle)                    
                    formData.append('animalNameSize', this.fontSizes.animalNameSize)            
                    formData.append('animalTextFont', this.selectedFontText)
                    formData.append('animalText', this.animalText)
                    formData.append('selectedDog', this.selectedDog)
                    formData.append('selectedCat', this.selectedCat)
                    formData.append('layout', this.selectedLayoutText)
                    formData.append('ornaments', this.selected_ornaments)
                    formData.append('usingPixInPortfolio', this.usingPixInPortfolio)

                    // for(var item of formData){
                    //     console.log('На отправку!', item)
                    //   }  

                    const config = { 
                        headers: { 'Content-Type':'multipart/form-data' } 
                    }
                    axios.post(this.apiURL + '?action=create', formData, config)
                         .then((res) => {
                            if(res.data.error){
                                this.errorMessage = res.data
                                console.log(res.data)
                            } else {
                                // this.orders = res.data.orders 
                                // this.ordersTotal = this.orders.length
                                console.log(res)  
                                this.successMessage = res.data                  
                            }
                        })
                    this.showingResultModal = false;
                    },
                clearMessages(){
                        this.errorMessage = '',
                        this.successMessage = ''
                    }
            }
    }
</script>

<style>
.laybox {
    min-height: 37px;
}
    .monument-font p {
        font-size: 23px;
    }

/* MODAL SUBMIT */    
    .modalContent {
        min-height: 333px;
        padding: 44px;
    }
    .modalContainer {
        width: 555px;
        background: #ffffff;
        margin: auto;
        margin-top: 44px;
        border-radius: 8px;
    }
    .modalHeading {
        padding: 9px;
        color: #ffffff;
    }
    .modBackground {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom:0;
        background: rgba(0,0,0,0.4);    z-index:99;
    }

/* UPLOADER STARTS */
    .textdanger {
    color: red;
    font-size:12pt;
    }
    .buffer {
    height: 240px;
    }
    .mb-15 {
        margin-bottom:15px!Important;
    }
    .uploader * {
        box-sizing: border-box;
    }
    .uploader-adction {
        padding: 20px;
        background: #f1f5ff;
        cursor: pointer;
        transition: background 300ms ease; 
    }
    .uploader-action .dz-message {
        color: #94a7c2;
        text-align: center;
        padding: 20px 40px;
        border-radius: 4px;
        font-size: 16px;
    }
    .uploader-files {
        flex: 1;
        padding: 40px;
    }
    .file-status {
        font-size: 12px;
        text-transform: uppercase;
        margin-left: 5px;
    }
    .uploader-action.dragging {
        background: #fff;
    }
    @keyframes slideUpIn {
        0% {
            opacity: 0;
            transform: translateY(10%);
        }
        100% {
            opacity: 1;
            transform: none;
        }
    }
/* UPLOADER END */

/* ORNAMENTS */
    .imgLeft,
    .imgRight,
    .imgMiddle,
    .ornament-frame {
        position: relative;
        cursor: pointer;
        border: 6px Solid #fff;    
    }
    .layout-close {
        cursor: pointer;
    }
    .layout-form-check {
        color: #d3cece;
        position: absolute;
        right: 23px!important;
        bottom: 4px!important;
        z-index: 1; 
        cursor: pointer;   
    }
    .layout-selected {
        border: 6px Solid #d3cece;
        border-radius: 6px;
    }
    .ornament-frame {
        border: 1px solid white;
        border-radius: 5px;
    }
    .check-frame {
        background-color: silver;
        border-radius: 5px;
        padding: 4px 10px;
        position: absolute;
        left: 20px!important;
        bottom: 10px!important;
        z-index: 1;
    }
    .orn-check-frame {
        position: absolute;
        z-index: 1;
        bottom: 0px;
        left: 0px;
    }
    .bg-black {
        background-color: black!Important;
    }
    .font-box:hover {
        border: 1px solid rgb(134, 130, 130)!Important;
    }

    /* ANIMATION START*/
    .fade-enter {
        opacity: 0;
    }
    .fade-enter-active {
        transition: 1s;
    }
    .fade-leave-active {
        transition: 1s;
        opacity: 0;
    }
/* ANIMATION END*/

/* DOGS AND CATS SILHOUETTES */
    .sihlouette-container {
        padding: 15px 0;
        /* background-color: black; */
        position: relative;
        overflow: hidden;
    }
    .animal-pic {
        cursor: pointer; 
        border-radius: 8px;
    }
    .selected-animal-silhouette {
        position: absolute;
        left: 10px!important;
        top: 10px!important;
        z-index: 1;
        width: 82%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Order/OrderForm.vue